import { render, staticRenderFns } from "./configManagement.vue?vue&type=template&id=45c89908&scoped=true"
import script from "./configManagement.vue?vue&type=script&lang=js"
export * from "./configManagement.vue?vue&type=script&lang=js"
import style0 from "./configManagement.vue?vue&type=style&index=0&id=45c89908&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c89908",
  null
  
)

export default component.exports